import React from "react";
import { StyledBreadcrumb } from "./styles";

const sections = [
  { key: "Painel de Controle", content: "Painel de Controle", href: "/admin/" },
  { key: "PocketBook4You", content: "PocketBook4You" },
  {
    key: "Listagem de Solicitações de parceria",
    content: "Listagem de solicitações",
    active: true,
  },
];

const Back = () => {
  return <StyledBreadcrumb icon="right angle" sections={sections} />;
};

export default Back;
